
import { useSidebarData } from "@/hooks/use-sidebar-data";
import { useNotifications } from "@/hooks/use-notifications";
import SidebarHeader from "./sidebar/SidebarHeader";
import SidebarMenu from "./sidebar/SidebarMenu";
import SidebarUserProfile from "./sidebar/SidebarUserProfile";

interface AdminSidebarProps {
  onCloseSidebar?: () => void;
}

const AdminSidebar = ({ onCloseSidebar }: AdminSidebarProps) => {
  const { isAdmin, userName, clientId, siteSettings, handleLogout, userAvatar } = useSidebarData();
  const { unreadCount, fetchUnreadCount } = useNotifications();
  
  console.log("AdminSidebar - userAvatar:", userAvatar); // Log per debug
  
  return (
    <div className="h-full w-64 bg-white border-r shadow-sm flex flex-col">
      <SidebarHeader 
        siteSettings={siteSettings} 
        onCloseSidebar={onCloseSidebar} 
      />

      <div className="flex-1 overflow-y-auto custom-scrollbar">
        <SidebarMenu 
          isAdmin={isAdmin} 
          clientId={clientId} 
          unreadCount={unreadCount} 
          fetchUnreadCount={fetchUnreadCount} 
        />
      </div>

      <SidebarUserProfile 
        userName={userName} 
        userRole={isAdmin ? 'Amministratore' : 'Utente'} 
        userAvatar={userAvatar}
        onLogout={handleLogout} 
      />
    </div>
  );
};

export default AdminSidebar;
